import React, { useEffect, useRef } from "react";
import Image from "next/image";
import { usePromoCodeActions } from "components/Basket/components/PromoCodes/hooks/usePromoCode";
import { LoadingMask } from "components/LoadingMask";
import { CheckIcon, CloseIcon } from "components/SVG";
import { promoCodeValue } from "components/Basket/components/PromoCodes/constants";
import * as styles from "./AddPromoCodeBox.css";

type Props = {
  className?: string;
};

export const AddPromoCodeBox = ({ className }: Props) => {
  const { onUsePromoCode, isPromoCodeActivated, isPromoCodeRejected } =
    usePromoCodeActions();
  const promoBox = useRef(null);
  const closePromoBanner = () => {
    const closePromoBox = promoBox.current as unknown as HTMLElement;
    closePromoBox.classList.add(styles.hideBox);
  };

  useEffect(() => {
    const closePromoBox = promoBox.current as unknown as HTMLElement;
    setTimeout(() => {
      closePromoBox.classList.add(styles.showPromoBox);
    }, 500);
  }, []);

  return (
    <>
      <div
        className={`${styles.promoMiniBasket} ${className || ""}`}
        ref={promoBox}
      >
        <Image
          className={styles.promoMiniImg}
          src="/images/promo-code/promo_code_box_img.jpg"
          alt=""
          width={512}
          height={466}
          title="image title"
          style={{
            objectFit: "cover",
            objectPosition: "center"
          }}
        />
        <div className={styles.promoMiniContent}>
          <p>Save 20% on your first order</p>
          {!isPromoCodeActivated && !isPromoCodeRejected ? (
            <p>
              <span
                className={styles.promoActivateCta}
                onClick={onUsePromoCode}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onUsePromoCode();
                  }
                }}
              >
                Activate Code
              </span>
              <span> {promoCodeValue}</span>
            </p>
          ) : (
            <p>
              <span className={styles.activatedPromoText}>
                <CheckIcon className={styles.promoBannerSvg} />
                {promoCodeValue} code activated
              </span>
            </p>
          )}
          <span className={styles.promoClose}>
            <CloseIcon
              onClick={closePromoBanner}
              className={styles.promoCloseBtn}
              width={20}
              height={20}
            />
          </span>
        </div>
        <LoadingMask />
      </div>
    </>
  );
};
